<ng-container *transloco="let t">
  <ng-container [ngSwitch]="userProfileComponentState">
    <app-page-template>
      <div class="container">
        <div class="pt-120-0 pb-300-100">
          <div class="d-flex flex-column justify-content-center align-items-center">
            <h1 class="d-none d-xl-flex">
              {{t('app.user.profile.settings')}} </h1>

            <div class="d-none d-xl-flex">
              <ng-container *ngTemplateOutlet="avatar"></ng-container>
            </div>
            <div class="d-flex justify-content-center align-items-center d-xl-none w-100">
              <div class="avatar-mobile-wrapper p-3 mt-4 mb-2 w-100">
                <ng-container *ngTemplateOutlet="avatar"></ng-container>
              </div>
            </div>

            <div *ngSwitchDefault>
              <form #userProfileFormEdit="ngForm" [formGroup]="inputForm">

                <!--                LG view-->
                <div class="d-none d-xl-flex flex-column  justify-content-center align-items-center ">
                  <app-section-card [title]="t('app.user.profile.personal.information')" [cardWidth]="'687px'">
                    <ng-container *ngIf="inputForm" [formGroup]="inputForm">
                      <ng-container *ngTemplateOutlet="basicInformation; context: { form: inputForm }"></ng-container>
                    </ng-container>
                  </app-section-card>
                  <div class="pt-4">
                    <app-section-card [title]="t('app.user.profile.other.information')" [cardWidth]="'687px'"
                                      [enableToggle]="false">
                      <ng-container *ngIf="inputForm" [formGroup]="inputForm">
                        <ng-container *ngTemplateOutlet="otherInformation; context: { form: inputForm }"></ng-container>
                      </ng-container>
                    </app-section-card>
                  </div>
                </div>

                <!--                Mobile view-->
                <div class="d-flex d-xl-none flex-column justify-content-center align-items-center ">
                  <app-nav-tabs [reduceHorizontalSpacing]=true>
                    <app-nav-tab [title]="t('app.user.profile.personal.information')" [itemId]="1">
                      <ng-template>
                        <ng-container *ngIf="inputForm" [formGroup]="inputForm">
                          <ng-container
                            *ngTemplateOutlet="basicInformation; context: { form: inputForm }"></ng-container>
                        </ng-container>
                      </ng-template>
                    </app-nav-tab>
                    <app-nav-tab [title]="t('app.user.profile.other.information')" [itemId]="2">
                      <ng-template>
                        <ng-container *ngIf="inputForm" [formGroup]="inputForm">
                          <ng-container
                            *ngTemplateOutlet="otherInformation; context: { form: inputForm }"></ng-container>
                        </ng-container>
                      </ng-template>
                    </app-nav-tab>
                  </app-nav-tabs>
                </div>

              </form>
            </div>
          </div>
        </div>
      </div>
    </app-page-template>
  </ng-container>

  <ng-template #basicInformation let-form="form">
    <div [formGroup]="form">
      <div class="row">
        <div class="col-12 col-xl-6 pt-3 pt-xl-0">
          <app-input formControlName="firstname" label="app.common.first.name"/>
        </div>
        <div class="col-12 col-xl-6 pt-3 pt-xl-0">
          <app-input formControlName="lastname" label="app.common.last.name"/>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-xl-6">
          <div class="pt-3">
            <app-select formControlName="gender" [items]="genders" [labelKey]="'id'" labelKeyPrefix="app.common.gender."
                        label="app.common.gender" valueKey="id"/>
          </div>
        </div>
        <div class="col-12 col-xl-6">
          <div class="pt-3">
            <div class="form-floating">
              <app-date-time-input formControlName="birthDay" [displayTime]="false" [openDate]="calendarNavigationDate"
                                   [displaySeconds]="false" [displayMilliseconds]="false"
                                   [minDate]="birthdayMinDate" [maxDate]="currentDate"
                                   [label]="t('app.common.birthDay')"/>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-xl-6">
          <div class="pt-3">
            <app-input formControlName="email" label="app.common.email"/>
          </div>
        </div>
        <div class="col-12 col-xl-6">
          <div class="pt-3">
            <app-tel-input [formControlName]="'phoneNumber'" [label]="t('app.common.phoneNumber')"
                           [numberPlaceholder]="t('app.common.phoneNumber')"></app-tel-input>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-xl-6">
          <div class="pt-3">
            <app-input formControlName="address" label="app.common.address"/>
          </div>
        </div>
        <div class="col-12 col-xl-6">
          <div class="pt-3">
            <app-input formControlName="city" label="app.common.placeOfResidence"/>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-xl-6">
          <div class="pt-3">
            <app-input formControlName="zip" label="app.common.zip"/>
          </div>
        </div>
        <div class="col-12 col-xl-6">
          <div class="pt-3">
            <app-select formControlName="country" [hasDefault]="true" [items]="countries" valueKey="id"
                        labelKey="id" labelKeyPrefix="app.common.country."
                        label="app.common.country"/>
          </div>
        </div>
      </div>
      <div class="d-block d-xl-none">
        <ng-container *ngTemplateOutlet="cta"></ng-container>
      </div>
    </div>
  </ng-template>

  <ng-template #otherInformation let-form="form">
    <div [formGroup]="form">
      <div class="row">
        <div class="col-12 col-xl-6">
          <div class="pt-3">
            <app-input formControlName="club" label="app.common.club"/>
          </div>
        </div>
        <div class="col-12 col-xl-6">
          <div class="pt-3">
            <app-tel-input [formControlName]="'emergencyPhone'" [label]="t('app.common.emergencyPhone')"
                           [numberPlaceholder]="t('app.common.emergencyPhone')"></app-tel-input>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="pt-3">
            <app-input formControlName="identityCardNumber" label="app.common.identityCardNumber"/>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-xl-6">
          <div class="pt-3">
            <div class="form-floating">
              <app-date-time-input formControlName="identityCardExpires" [displayTime]="false"
                                   [minDate]="currentDate" [label]="t('app.common.identityCardExpires')"/>
            </div>
          </div>
        </div>
        <div class="col-12 col-xl-6">
          <div class="pt-3">
            <app-input formControlName="identityCardIssuer" label="app.common.identityCardIssuer"/>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-xl-6">
          <div class="pt-3">
            <app-select formControlName="tshirtSize" [hasDefault]="true" [items]="tshirtSizes" labelKey="name"
                        valueKey="alternativeId" label="app.common.tshirtSize"/>
          </div>
        </div>
        <div class="col-12 col-xl-6">
          <div class="pt-3">
            <app-select formControlName="meal" [hasDefault]="true" [items]="meals" labelKey="alternativeId"  labelKeyPrefix="app.common.meal."
                        valueKey="alternativeId"
                        label="app.common.meal"/>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="pt-3">
            <app-input formControlName="nickname" label="app.common.nickname"/>
          </div>
        </div>
      </div>
      <ng-container *ngTemplateOutlet="cta"></ng-container>
    </div>
  </ng-template>

  <ng-template #avatar>
    <div class="d-flex flex-column justify-content-center align-items-center">
      <div class="avatar-wrapper pt-0 pt-xl-3">
        <div class="el-1">
          <div>
            <input type="file" accept="image/*" #file (change)="processFile(file)">
            @if (profilePicture) {
              <button class="avatar-button" (click)="file.click()">
                <img [src]="profilePicture" class="avatar" alt="Avatar">
              </button>
            } @else {
              <button class="avatar-button" (click)="file.click()">
                <img src="assets/img/blank_profile.webp" class="avatar" alt="Avatar">
              </button>
            }
          </div>
        </div>
        @if (profilePicture && editProfilePictureMode) {
          <div class="el-2">
            <button (click)="onDeleteProfilePicture()" class="btn shadow btn-circle blue-btn">
              <i class="bi bi-x-lg bold"></i>
            </button>
          </div>
        }
        @if (editProfilePictureMode) {
          <div class="el-3">
            <input type="file" accept="image/*" #file (change)="processFile(file)">
            <button (click)="file.click()" class="btn shadow btn-circle black-btn">
              <i class="bi bi-upload bi-bold"></i>
            </button>
          </div>
        } @else {
          <div class="el-3">
            <button type="button" (click)="onEditProfilePicture()"
                    class="btn shadow btn-circle blue-btn d-none d-xl-flex align-items-center justify-content-center">
              <img src="assets/icons/icons-alt/edit.svg" alt="Edit">
            </button>
            <div class="d-flex d-xl-none btn-circle-xs"  (click)="onEditProfilePicture()">
              <img src="assets/icons/icons-alt/edit-avatar-xs.svg" alt="Edit">
            </div>
          </div>
        }
      </div>
      <div class="pb-0 pb-xl-5 pt-3 pt-xl-0">
        <p class="large pt-1 text-uppercase">
          {{currentUserDetails?.firstname}} {{currentUserDetails?.lastname}} </p>
      </div>
    </div>
  </ng-template>

  <ng-template #cta>
    <div class="row pt-4">
      <div class="col-12 col-md-6">
        <app-button-alt [text]="t('app.common.go.to.dashboard')" [borderColor]="'var(--teal-500)'"
                        [textColor]="'var(--grey-neutral-800)'" (onClickCallback)="toProfilePage()"
                        [buttonColor]="'transparent'" [isFullWidth]="true"/>
      </div>
      <div class="col-12 col-md-6 pt-3 pt-md-0">
        <app-button-alt [buttonColor]="'var(--teal-500)'" [textColor]="'white'" [text]="t('app.user.profile.update')"
                        [borderColor]="'var(--teal-500)'" (onClickCallback)="onUpdateProfile()"
                        [isFullWidth]="true"></app-button-alt>
      </div>
    </div>
  </ng-template>
</ng-container>


<!--              TODO SUCCESS--><!--<div *ngSwitchCase="userProfileComponentStateType.SUCCESS">--><!--  <div class="d-flex justify-content-center flex-column align-items-center">--><!--    <h1 class="text-uppercase pb-4">{{ t('signup.your.adventure.can.start') }}</h1>--><!--    <div class="rounded-circle d-inline-flex align-items-center justify-content-center">--><!--      <i class="bi bi-check2"></i>--><!--    </div>--><!--    <span class="success-text-wrapper pt-4">--><!--                  {{ t('signup.email.sent.with.verification.link') }}--><!--                </span>--><!--  </div>--><!--  <div class="pt-5">--><!--    <app-button [label]="t('app.common.go.back')" [btnClass]="'btn-primary-red btn-large'"/>--><!--  </div>--><!--</div>--><!--<div *ngSwitchDefault>--><!--</div>-->
